import { createStyles, rem } from "@mantine/core";
import { rgba } from "polished";

export const useStyles = createStyles((theme) => ({
  emptyState: {
    width: "100%",
    height: "100%",
    flexDirection: "column",
    gap: rem(16),
  },

  emptyIcon: {
    opacity: 0.5,
  },

  statusTextValid: {
    color: theme.colors.green[0],
    fontWeight: 700,
  },

  statusTextForged: {
    color: theme.colors.red[0],
  },

  statusHighlight: {
    fontWeight: 700,
  },

  checkItemPassed: {
    padding: `${rem(12)} ${rem(16)}`,
    borderRadius: rem(4),
    backgroundColor: rgba(theme.colors.green[0], 0.1),
    border: `1px solid ${theme.colors.green[0]}`,
    gap: rem(12),
  },

  checkItemFailed: {
    padding: `${rem(12)} ${rem(16)}`,
    borderRadius: rem(4),
    backgroundColor: rgba(theme.colors.red[0], 0.1),
    border: `1px solid ${theme.colors.red[0]}`,
    gap: rem(12),
  },
}));
